module.exports = __webpack_public_path__ + "nu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/nu.svg
// module id = 997
// module chunks = 0